<template lang="pug">
app-main-content
  .c-resources-page
    //- Header Section
    section.c-resources-page__header
      .c-resources-page__header-content
        h1.c-resources-page__heading Resources
        p.c-resources-page__subtitle Manage onboarding checklists, help links, todos and workflows

    //- Tab Navigation
    section.c-resources-page__nav-section(v-if="$route.path !== '/manage-resources'")
      .c-resources-page__nav-wrapper
        .c-resources-nav
          router-link.c-resources-nav-link(
            to="/manage-resources/onboarding"
            :class="{ 'c-resources-nav-link--active': $route.path.includes('/onboarding') }"
          ) Onboarding
          router-link.c-resources-nav-link(
            to="/manage-resources/help-links"
            :class="{ 'c-resources-nav-link--active': $route.path.includes('/help-links') }"
          ) Help links
          router-link.c-resources-nav-link(
            to="/manage-resources/help-insights"
            :class="{ 'c-resources-nav-link--active': $route.path.includes('/help-insights') }"
          ) Help insights
          router-link.c-resources-nav-link(
            to="/manage-resources/todos"
            :class="{ 'c-resources-nav-link--active': $route.path.includes('/todos') }"
          ) Todos
          router-link.c-resources-nav-link(
            to="/manage-resources/workflows"
            :class="{ 'c-resources-nav-link--active': $route.path.includes('/workflows') }"
          ) Workflows
        
        .c-resources-page__nav-actions
          #resource-actions-portal

    //- Empty State
    template(v-if="$route.path === '/manage-resources'")
      .c-resources-empty
        p.c-resources-empty__text Select a section from above to manage resources

    //- Content
    router-view(v-slot="{ Component }" v-else)
      transition(name="fade" mode="out-in")
        component(:is="Component")
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ManageResources',
});
</script>

<style lang="scss" scoped>
@import '@/views/manage-users-and-organizations/crm-list';

.c-resources-page {
  @include crm-page;

  &__nav-section {
    display: block;
  }

  &__nav-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 1rem;
  }

  &__nav-actions {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
  }
}

@include crm-header('c-resources-page');
@include crm-tabs('c-resources-nav', 'c-resources-nav-link');

.c-resources-nav {
  width: auto;
  max-width: 100%;
}

.c-resources-nav-link {
  padding: 4px 16px;

  &:hover:not(.c-resources-nav-link--active) {
    background-color: rgba(255, 255, 255, 0.5);
  }
}

.c-resources-empty {
  @include crm-card;
  padding: 3rem 2rem;
  text-align: center;

  &__text {
    font-size: 0.875rem;
    color: $gray-600;
    margin: 0;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@media (max-width: 768px) {
  .c-resources-page {
    padding: 1.5rem;

    &__nav-wrapper {
      flex-direction: column;
      align-items: flex-start;
    }

    &__nav-actions {
      width: 100%;
    }
  }

  .c-resources-nav {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .c-resources-page {
    padding: 1rem;
  }
}
</style>
